import React, { useEffect, useState } from "react";

export default function ThemeToggle() {
    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const stored = localStorage.getItem("theme");
        const prefersDark = window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches;

        const initial = stored || (prefersDark ? "dark" : "light");
        setTheme(initial);
        applyTheme(initial);
    }, []);

    const applyTheme = (mode) => {
        const root = document.documentElement;
        if (mode === "dark") {
            root.classList.add("dark");
            root.style.colorScheme = "dark";
        } else {
            root.classList.remove("dark");
            root.style.colorScheme = "light";
        }
    };

    const toggleTheme = () => {
        const next = theme === "light" ? "dark" : "light";
        setTheme(next);
        localStorage.setItem("theme", next);
        applyTheme(next);
    };

    const isDark = theme === "dark";

    return (
        <button
            type="button"
            onClick={toggleTheme}
            className="inline-flex items-center gap-2 rounded-full border border-slate-200/80 bg-white/80 px-3 py-1 text-xs font-medium text-slate-700 shadow-sm backdrop-blur hover:border-slate-300 hover:bg-white dark:border-slate-700/80 dark:bg-slate-900/90 dark:text-slate-200 dark:hover:border-slate-600 transition-colors"
        >
            <span
                className={
                    "inline-flex h-4 w-4 items-center justify-center rounded-full text-[10px] " +
                    (isDark ? "bg-slate-800 text-amber-300" : "bg-slate-100 text-amber-500")
                }
            >
                {isDark ? "☾" : "☀︎"}
            </span>
            <span>{isDark ? "Dark" : "Light"}</span>
        </button>
    );
}
